export default __webpack_public_path__ + "static/media/IMG_9778 copie.b7e0829c.jpg";